import MutasiBarangJadiApi from './MutasiAntarGudangApi';

export default MutasiBarangJadiApi;
